import 'rx-lite';

export class LCTool_ReadMarker {
	private static contentelements: {
		ce: JQuery<HTMLElement>,
		tocelement: JQuery<HTMLElement>;
	}[] = [];

	public static setupReadMarkers_Initial(): void {
		const tocelements = $('div.homeworkContainer');

		$.each(tocelements, (idx, e) => {
			const $e = $(e);
			const id = $e.attr('data-homeworkid');
			if (!id) {
				//throw 'data-homeworkid properties not found';
				return true;
			}

			const actualId = 'ACH' + id;

			const contentElement = $('#' + actualId);
			if (contentElement.length !== 1) {
				const msg = "contentElement.length !== 1 (" + actualId + ")";
				console.warn(msg);
				return true;
				//throw msg;
			}

			const $contentelement = $(contentElement[0]);
			$contentelement.on('resize', () => {
				LCTool_ReadMarker.setReadMarkers();
			});

			LCTool_ReadMarker.contentelements.push({
				ce: $contentelement,
				tocelement: $e.find('.readingprogress')
			});

			return true;
		});

		LCTool_ReadMarker.setReadMarkers(); //initial

		Rx.Observable.fromEvent(window, "scroll")
			.merge(Rx.Observable.fromEvent(window, "resize"))
			.throttle(250)
			.subscribe(() => { LCTool_ReadMarker.setReadMarkers(); });
	}

	public static setReadMarkers(): void {
		const $window = $(window);
		const windowScrolltop = $window.scrollTop()!;
		const windowHeight = $window.outerHeight()!;
		const windowSweetspot = windowScrolltop + windowHeight / 10;

		const distances = $.map(LCTool_ReadMarker.contentelements, (obj, i) => {
			let article = obj.ce.children("article");

			if (article.length === 0)
				article = obj.ce;

			const articleTop = article.offset()!.top;

			const articleHeight = article.outerHeight(false)!;
			const articleBottom = articleTop + articleHeight;

			const distanceToSweetspot = Math.abs(articleTop - windowSweetspot);
			let distance: number;
			//hvis artiklen ikke er i scope så skal der meget til at den bliver market som den aktive...
			if (articleTop < windowScrolltop && articleBottom > (windowScrolltop + windowHeight)) {
				distance = 100 * distanceToSweetspot;
			} else {
				distance = distanceToSweetspot;
			}

			return {
				obj: obj,
				distance: distance
			}
		});

		const sorted = distances.sort((o1, o2) => o1.distance - o2.distance);

		$.each(sorted, (idx, o) => {
			if (idx === 0) {
				LCTool_ReadMarker.setProgressReaderDisplay(o.obj.tocelement, 100);
			} else {
				LCTool_ReadMarker.setProgressReaderDisplay(o.obj.tocelement, 0);
			}
		});
	}

	private static setProgressReaderDisplay(element: JQuery, percent: number) {
		element.css('background-image', 'linear-gradient(to bottom, #60AFFE, #60AFFE ' + percent + '%, #f7f7f7 ' + percent + '%)');
	}
}